import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import {
  ZGetTokenTransactionResponse,
  ZTokenRedemptionInsert,
  ZTokenRedemptionOptionsItem,
  ZTokenRedemptionSelect,
} from './models';

const c = initContract();
export const adminTokenContract = c.router(
  {
    getTokenBalanceOfPlayer: {
      method: 'GET',
      path: '/token-balance',
      query: z.object({
        playerId: z.string(),
      }),
      responses: {
        200: z.number(),
        404: z.object({
          message: z.string(),
        }),
      },
    },

    getTokenTransactionsOfPlayer: {
      method: 'GET',
      path: '/token-transactions',
      query: z.object({
        playerId: z.string(),
        page: z.coerce.number(),
        pageSize: z.coerce.number(),
      }),
      responses: {
        200: ZGetTokenTransactionResponse,
        404: z.object({
          message: z.string(),
        }),
      },
    },

    awardTokensToPlayer: {
      method: 'POST',
      path: '/award-tokens',
      body: z.object({
        playerId: z.string(),
        quantity: z.coerce.number().min(1),
      }),
      responses: {
        200: z.object({
          newBalance: z.number(),
        }),
        400: z.object({
          message: z.string(),
        }),
        404: z.object({
          message: z.string(),
        }),
      },
    },

    getAllTokenRedemptionOptions: {
      method: 'GET',
      path: '/all-token-redemption-options',
      responses: {
        200: ZTokenRedemptionOptionsItem.array(),
      },
    },

    updateTokenRedemptionOptionGroupOrder: {
      method: 'POST',
      path: '/update-redemption-option-group-order',
      body: z.object({
        group: z.string(),
        reorderedOptionIds: z.array(z.coerce.number()),
      }),
      responses: {
        200: ZTokenRedemptionOptionsItem.array(),
        400: z.object({
          message: z.string(),
        }),
      },
    },

    cancelTokenRedemptions: {
      method: 'POST',
      path: '/cancel-token-redemptions',
      body: z.object({
        tokenRedemptionIds: z.array(z.string()),
      }),
      responses: {
        200: z.object({
          success: z.literal(true),
        }),
        400: z.object({
          message: z.string(),
          reason: z
            .union([
              z.literal('PRIZE_TYPE_BUNDLE'),
              z.literal('GIFTCLOUD_GIFT_CARD'),
              z.literal('DAYMADE_FULFILLED'),
              z.literal('PRIZE_ORDER_ALREADY_CANCELLED'),
              z.literal('PRIZE_ORDER_PRODUCT_ALREADY_CANCELLED'),
            ])
            .optional(),
        }),
      },
    },

    updateTokenRedemption: {
      method: 'PATCH',
      path: '/token-redemption/:id',
      pathParams: z.object({ id: z.string() }),
      body: z.object({
        tokenRedemption: ZTokenRedemptionInsert.pick({
          notes: true,
        }),
      }),
      responses: {
        200: z.object({ tokenRedemption: ZTokenRedemptionSelect }),
        400: c.type<{ message: string }>(),
      },
    },
  },
  {
    pathPrefix: '/admin',
    commonResponses: {
      401: c.type<{ message: string; statusCode: 401 }>(),
      403: c.type<{ message: string; statusCode: 403 }>(),
    },
  },
);
